export default __webpack_public_path__ + "static/media/Elijah_BIO_Image.f3df5d32.jpg";